import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "objectLength",
})
export class ObjectLengthPipe implements PipeTransform {
  public transform(object: Record<string, unknown>): number {
    if (!object) {
      return 0;
    }

    return Object.keys(object).length;
  }
}
